import { render, staticRenderFns } from "./index.vue?vue&type=template&id=a0c1868a&scoped=true&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a0c1868a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\wwwroot\\dealer-web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a0c1868a')) {
      api.createRecord('a0c1868a', component.options)
    } else {
      api.reload('a0c1868a', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=a0c1868a&scoped=true&", function () {
      api.rerender('a0c1868a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/base/qualifications/index.vue"
export default component.exports